import { useStaysPropertyForm } from '@/hooks/stays/useStaysPropertyForm'
import { StProperty } from '@/types'
import { Box, Button, HStack, VStack } from '@chakra-ui/react'
import { FormProvider } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import { StaysPropertyStep } from '../PropertyFormRHF/steps/StaysPropertyStep'
import { ConfirmationModal } from './components/ConfirmationModal'

interface StaysPropertyFormProps {
  st_property?: StProperty | null
}

export const StaysPropertyForm = ({ st_property }: StaysPropertyFormProps) => {
  const navigate = useNavigate()
  const {
    form,
    control,
    handleSubmit: hookHandleSubmit,
    onSubmit,
    isLoading,
    // errors,
    isOpen,
    onClose,
    selectedStaysProperty,
    setSelectedStaysProperty,
  } = useStaysPropertyForm({
    st_property,
  })

  const { handleSubmit, ...hooForm } = form

  return (
    <>
      <FormProvider handleSubmit={hookHandleSubmit} {...hooForm}>
        <Box className="flex flex-col justify-between h-full gap-2">
          <VStack
            spacing={8}
            as="form"
            onSubmit={hookHandleSubmit(onSubmit)}
            noValidate
            w={'full'}
          >
            <StaysPropertyStep control={control} />
            <HStack w="full" columnGap={4} p={2} justifyContent={'flex-end'}>
              <Button
                type="button"
                variant="ghost"
                onClick={() => navigate(-1)}
                colorScheme="red"
                className="bg-red-100/30 hover:bg-red-300/40"
              >
                Cancelar
              </Button>
              <Button type="submit" colorScheme="green" isLoading={isLoading}>
                Criar Propriedade Stays
              </Button>
            </HStack>
          </VStack>
        </Box>
      </FormProvider>
      <ConfirmationModal
        isOpen={isOpen}
        onClose={onClose}
        selectedStaysProperty={selectedStaysProperty}
        setSelectedStaysProperty={setSelectedStaysProperty}
      />
    </>
  )
}
